// extracted by mini-css-extract-plugin
module.exports = {"pdp":"_2YEbM","slick-slider":"_2zBCt","bottomStrip":"CdJ57","slideContent":"_17MGN","iconLeft":"_37_ng","iconRight":"_3jPBi","textContainer":"_2eWse","shake":"vhmoI"};